import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
//
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
// ----------------------------------------------------------------------

RHFCalender.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFCalender({ name, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
          <DatePicker
            {...field}
            value={field?.value || ''}
            error={!!error}
            helperText={error ? error?.message : helperText}
            format="YYYY/MM/DD"
            calendar="persian"
            locale="fa"
            calendarPosition="center"
            {...other}
            fullWidth
          />
        </LocalizationProvider>
      )}
    />
  );
}
